import { render, staticRenderFns } from "./internalResultDetail.vue?vue&type=template&id=642e2c05"
import script from "./internalResultDetail.vue?vue&type=script&lang=js"
export * from "./internalResultDetail.vue?vue&type=script&lang=js"
import style0 from "./internalResultDetail.vue?vue&type=style&index=0&id=642e2c05&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642e2c05')) {
      api.createRecord('642e2c05', component.options)
    } else {
      api.reload('642e2c05', component.options)
    }
    module.hot.accept("./internalResultDetail.vue?vue&type=template&id=642e2c05", function () {
      api.rerender('642e2c05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/temp2/internalResultDetail.vue"
export default component.exports